import React from 'react'

import {classes} from './WebTipsIframe.classes'

type Props = {
  iframeUrl: string | undefined
}

function WebTipsIframe({iframeUrl}: Props): React.ReactElement<Props> {
  return <iframe className={classes.root} src={iframeUrl} title="Tips" />
}

export default WebTipsIframe
